const CROSSHAIRS = [
  { top: "12%", left: "8%" },
  { top: "18%", right: "12%" },
  { bottom: "22%", left: "14%" },
  { bottom: "12%", right: "8%" },
];

export default function BlueprintOverlay({ dimLabel = "ÉCHELLE 1:1", stamp = "DWG — DEMOIVRE" }) {
  return (
    <div className="pointer-events-none absolute inset-0" aria-hidden="true">
      <div className="absolute inset-0 bp-grid" />
      {CROSSHAIRS.map((pos, i) => (
        <span key={i} className="tick" style={pos} />
      ))}
      <div className="absolute top-6 left-1/2 h-px w-24 -translate-x-1/2 bg-brass/30">
        <span className="absolute -top-1 left-0 h-2 w-px bg-brass/50" />
        <span className="absolute -top-1 right-0 h-2 w-px bg-brass/50" />
        <span className="absolute -top-5 left-1/2 -translate-x-1/2 font-mono text-[9px] tracking-[0.25em] text-brass/60">
          {dimLabel}
        </span>
      </div>
      <div className="absolute bottom-4 right-4 border border-bone/10 px-3 py-2 font-mono text-[9px] leading-relaxed tracking-[0.2em] text-bone-muted/70">
        <span className="block">{stamp}</span>
        <span className="block">FORMAT — TOILE · ENCRE</span>
      </div>
    </div>
  );
}
